"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var base_condition_1 = require("./base.condition");
var models_1 = require("../../models");
var PageCountBySiteCondition = /** @class */ (function (_super) {
    __extends(PageCountBySiteCondition, _super);
    function PageCountBySiteCondition(visits, options, notificationService) {
        var _this = _super.call(this, "PageCountBySiteCondition", notificationService) || this;
        var TIMESTAMPMULTIPLIER = 60 * 1000;
        var siteLastVisits;
        var span;
        _this.observable = new Observable_1.Observable(function (observer) {
            if (!options.hasOwnProperty('Min') && !options.hasOwnProperty('Max')) { // if Min and Max are not present
                _this.onConditionFail(models_1.ConditionFailReason.ConfigurationError, "Mandatory Min/Max or both parameters are missing. PageCountBySiteCondition condition failed!!");
                observer.next(false);
                return;
            }
            span = options.hasOwnProperty("MinutesWithin") ? options.MinutesWithin : Infinity;
            var spanStart = (span != Infinity) ? Date.now() - span * TIMESTAMPMULTIPLIER : 0;
            siteLastVisits = visits.filter(function (x) { return x.hasOwnProperty('TimeStamp') && x.TimeStamp >= spanStart; });
            console.log("No of time site visited in last " + span + " minutes is :: " + siteLastVisits.length);
            if (options.hasOwnProperty("Max") && siteLastVisits.length > options.Max) {
                observer.next(false);
                _this.onConditionFail(models_1.ConditionFailReason.CriteriaFail, "PageCountBySiteCondition condition failed!!");
                return;
            }
            if (options.hasOwnProperty("Min") && siteLastVisits.length < options.Min) {
                observer.next(false);
                _this.onConditionFail(models_1.ConditionFailReason.CriteriaFail, "PageCountBySiteCondition condition failed!!");
                return;
            }
            observer.next(true);
            console.log("PageCountBySiteCondition condition passed!!");
        });
        return _this;
    }
    return PageCountBySiteCondition;
}(base_condition_1.BaseCondition));
exports.PageCountBySiteCondition = PageCountBySiteCondition;
